<script>
import { useRuntimeTemplate } from '@Common/Composables/runtime-template';
import { computed, onMounted } from 'vue';
import VRuntimeTemplate from 'vue3-runtime-template';
import Query from './Components/Query.vue';
import Button from '@Common/Components/Buttons/Button.vue';
import useCurrentLocale from '../../Common/Composables/current-locale';
import { useI18n } from 'vue-i18n';

export default {
    /* eslint-disable vue/no-unused-components */
    components: {
        VRuntimeTemplate,
        Query,
        Button
    },
    props: {
        templateUrl: { type: String, required: true },
        cssUrl: { type: String, required: true },
        queryUrl: { type: String, required: true }
    },
    setup(props) {
        const {
            templateContent,
            getTemplate
        } = useRuntimeTemplate(props.templateUrl, props.cssUrl, props.queryUrl);

        const {
            currentLocale,
            urlWithLocale,
            formatCurrency,
            formatNumber,
            isoLocale,
            weekInfo
        } = useCurrentLocale();
        const { t } = useI18n();
        const global = window;

        const templateProps = computed(() => ({
            currentLocale: currentLocale.value,
            urlWithLocale: urlWithLocale.value,
            formatCurrency: formatCurrency.value,
            formatNumber: formatNumber.value,
            isoLocale: isoLocale.value,
            weekInfo: weekInfo.value,
            t,
            global
        }));

        onMounted(async () => {
            getTemplate();
        });

        return {
            templateContent,
            templateProps
        };
    }
};
</script>
<template>
    <v-runtime-template v-if="templateContent" :template="templateContent" :template-props="templateProps"/>
</template>